(() => {
  const CONFIG = {
    klaviyoCompany: 'Le5SFR',
    klaviyoList: 'SpH8KD',
    earlyAccess: new Date('2026-11-04T12:00:00+10:00'),
    publicSale: new Date('2026-11-05T12:00:00+10:00'),
    shopUrl: 'https://au.blacksheep.cc/collections/black-friday-sale',
    storeKey: 'bs-bf26-ticket'
  };

  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const wait = ms => new Promise(r => setTimeout(r, ms));
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const pad = (n, l = 6) => String(n).padStart(l, '0');

  const store = {
    get() { try { return JSON.parse(localStorage.getItem(CONFIG.storeKey)); } catch { return null; } },
    set(v) { try { localStorage.setItem(CONFIG.storeKey, JSON.stringify(v)); } catch {} },
    clear() { try { localStorage.removeItem(CONFIG.storeKey); } catch {} }
  };

  /* Barcode: bars drawn from the ticket number */
  function barcode(el, num) {
    const seed = String(num).replace(/\D/g, '') || '000000';
    const widths = [1, 2, 3, 5];
    let html = '';
    for (let i = 0; i < 46; i++) {
      const d = +seed[i % seed.length] + i * 7;
      html += `<span style="--w:${widths[d % 4]}px;--g:${widths[(d >> 2) % 3]}px"></span>`;
    }
    el.innerHTML = html;
  }
  $$('[data-barcode]').forEach(el => barcode(el, el.dataset.barcode || '804211'));

  /* Hero reels */
  function reelTicket(i, single, flip) {
    const n = (k) => `BS 0 000 ${pad(k, 3)}`;
    const prize = Math.floor(i / 2) % 2 ? ['Golden Ticket', 'Black Sheep'] : ['Win a Trip', 'To Adelaide'];
    const a = `<div class="rt__cell"><span class="rt__big">${prize[0]}</span><span class="rt__sm">${prize[1]}</span><span class="rt__n">${n(i * 2 + 1)}</span></div>`;
    const b = `<div class="rt__cell"><span class="rt__big rt__big--dot">Black Friday</span><span class="rt__sm">Up to 60% off</span><span class="rt__n">${n(i * 2 + 2)}</span></div>`;
    return `<div class="rt">${single ? b : flip ? b + a : a + b}</div>`;
  }
  // Three ticket designs repeated across both scrolling strips.
  const figmaTickets = [
    { title: 'BLACK FRIDAY', prize: 'UP TO 60% OFF SITE-WIDE', number: 'Nº008421' },
    { title: 'A YEAR OF KIT', prize: 'WIN KIT FOR EVERY SEASON', number: 'Nº008422' },
    { title: 'TOUR BOUND', prize: 'WIN A TRIP TO ADELAIDE', number: 'Nº008423' }
  ];
  function scrollingTicket(ticket) {
    return `<div class="figma-ticket-slot"><div class="figma-ticket">
      <img class="figma-ticket__base" src="${window.BF26_ASSET_BASE}bf26-ticket-base.svg" alt="">
      <img class="figma-ticket__edge figma-ticket__edge--left" src="${window.BF26_ASSET_BASE}bf26-ticket-left.svg" alt="">
      <img class="figma-ticket__edge figma-ticket__edge--right" src="${window.BF26_ASSET_BASE}bf26-ticket-right.svg" alt="">
      <span class="figma-ticket__border figma-ticket__border--top"></span>
      <span class="figma-ticket__title">${ticket.title}</span>
      <span class="figma-ticket__border"></span>
      <span class="figma-ticket__detail"><strong>${ticket.prize}</strong><span>${ticket.number}</span></span>
    </div></div>`;
  }
  $$('[data-reel]').forEach(track => {
    const strip = Array.from({ length: 12 }, (_, i) => scrollingTicket(figmaTickets[i % 3])).join('');
    track.innerHTML = `<div class="reel__sequence" aria-hidden="true">${strip}</div><div class="reel__sequence">${strip}</div><div class="reel__sequence" aria-hidden="true">${strip}</div>`;
  });
  $$('[data-loose]').forEach((el, i) => { el.innerHTML = reelTicket(40 + i, true); });

  /* Countdown */
  const clock = $('.clock');
  const units = { d: $('[data-u="d"]'), h: $('[data-u="h"]'), m: $('[data-u="m"]'), s: $('[data-u="s"]') };
  function tick() {
    const now = Date.now();
    let diff = CONFIG.earlyAccess - now;
    if (diff <= 0) {
      clock.classList.add('is-open');
      $('[data-clock-label]').textContent = now < CONFIG.publicSale ? 'Check your inbox for access.' : 'Check your inbox for access.';
      clock.href = '#saleIntro';
      $('[data-clock-go]').textContent = 'Get in early →';
      return;
    }
    const d = Math.floor(diff / 864e5); diff -= d * 864e5;
    const h = Math.floor(diff / 36e5); diff -= h * 36e5;
    const m = Math.floor(diff / 6e4); diff -= m * 6e4;
    const s = Math.floor(diff / 1e3);
    units.d.textContent = pad(d, 2); units.h.textContent = pad(h, 2);
    units.m.textContent = pad(m, 2); units.s.textContent = pad(s, 2);
  }
  tick(); setInterval(tick, 1000);

  // Keep the sticky clock out of both registration sections and the mobile end sections.
  const signupVisibility = new Map();
  const mobileHero = window.matchMedia('(max-width: 720px)');
  const prizeLink = $('.hero__actions .btn--hero-outline');
  function updatePrizeLink() {
    prizeLink.href = mobileHero.matches ? '#draw' : '#saleTicketLanding';
  }
  updatePrizeLink();
  mobileHero.addEventListener('change', updatePrizeLink);
  const hero = $('#top');
  const closingBand = $('.band.perf');
  let heroVisible = hero.getBoundingClientRect().bottom > 0 && hero.getBoundingClientRect().top < window.innerHeight;
  let closingBandVisible = closingBand.getBoundingClientRect().bottom > 0 && closingBand.getBoundingClientRect().top < window.innerHeight;
  function updateClockVisibility() {
    clock.classList.toggle('is-hidden', [...signupVisibility.values()].some(Boolean) || (mobileHero.matches && (heroVisible || closingBandVisible)));
    clock.classList.add('is-ready');
  }
  updateClockVisibility();
  const signupObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => signupVisibility.set(entry.target, entry.isIntersecting));
    updateClockVisibility();
  }, { threshold: .25 });
  signupObserver.observe($('.sale-intro__stage'));
  if (location.hash === '#ticket') {
    history.replaceState(null, '', '#saleIntro');
    requestAnimationFrame(() => $('#saleIntro').scrollIntoView());
  }
  const mobileEndsObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.target === hero) heroVisible = entry.isIntersecting;
      if (entry.target === closingBand) closingBandVisible = entry.isIntersecting;
    });
    updateClockVisibility();
  });
  mobileEndsObserver.observe(hero);
  mobileEndsObserver.observe(closingBand);
  mobileHero.addEventListener('change', updateClockVisibility);

  /* Ticket dispenser */
  const feed = $('[data-feed]');
  const holder = $('[data-tk]');
  const formTpl = holder.innerHTML;
  const introForms = $$('[data-intro-form]');
  introForms.forEach((form, index) => {
    const source = $('[data-form]', holder);
    const target = $('[data-intro-fields]', form);
    ['.fields', '.tk__foot', '.tk__fine', '.tk__err'].forEach(selector => {
      target.append($(selector, source).cloneNode(true));
    });
    $('[data-print]', form).textContent = 'Sign up for the sale';
    $$('[id]', form).forEach(input => {
      const oldId = input.id;
      input.id = `intro-${index}-${oldId}`;
      $$(`label[for="${oldId}"]`, form).forEach(label => { label.htmlFor = input.id; });
    });
  });
  const introFormTpls = introForms.map(form => form.innerHTML);
  const head = { title: $('[data-head-title]'), lead: $('[data-head-lead]'), actions: $('[data-head-actions]') };
  const headDefault = { title: head.title.innerHTML, lead: head.lead.textContent };

  function play(cls) {
    if (still) return Promise.resolve();
    feed.classList.remove('is-in', 'is-out');
    void feed.offsetWidth;
    feed.classList.add(cls);
    return wait(cls === 'is-in' ? 560 : 1900);
  }

  function nextNumber() {
    const since = Date.UTC(2026, 9, 20);
    return 8400 + Math.max(0, Math.floor((Date.now() - since) / 4.2e5)) + Math.floor(Math.random() * 4);
  }

  function roll(els, final, ms = 900) {
    if (still) { els.forEach(el => el.textContent = final); return Promise.resolve(); }
    const start = performance.now();
    return new Promise(done => {
      (function frame(t) {
        const p = Math.min(1, (t - start) / ms);
        const locked = Math.floor(p * final.length);
        const txt = final.split('').map((c, i) => i < locked ? c : Math.floor(Math.random() * 10)).join('');
        els.forEach(el => el.textContent = txt);
        if (p < 1) requestAnimationFrame(frame); else done();
      })(start);
    });
  }

  // Mobile numbers go to Klaviyo in E.164. A leading + skips the country picker.
  function normaliseMobile(v, cc = '61') {
    let raw = v.replace(/[\s().-]/g, '');
    if (raw.startsWith('00')) raw = '+' + raw.slice(2);
    if (!raw.startsWith('+')) {
      if (!cc || !/^\d+$/.test(raw)) return null;
      raw = '+' + cc + raw.replace(/^0/, '');
    }
    if (raw.startsWith('+61') && !/^\+614\d{8}$/.test(raw)) return null;
    return /^\+[1-9]\d{7,14}$/.test(raw) ? raw : null;
  }

  document.addEventListener('change', e => {
    const cc = e.target.closest('[data-cc]');
    if (!cc) return;
    cc.closest('.phone').querySelector('[name="mobile"]').placeholder = cc.selectedOptions[0].dataset.ph;
    cc.closest('.field').classList.remove('is-bad');
  });

  function validate(form) {
    let ok = true;
    const mark = (el, bad) => { el.classList.toggle('is-bad', bad); if (bad) ok = false; };
    const f = form.elements;
    mark(f.first.closest('.field'), !f.first.value.trim());
    mark(f.last.closest('.field'), !f.last.value.trim());
    mark(f.email.closest('.field'), !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(f.email.value.trim()));
    mark(f.mobile.closest('.field'), !normaliseMobile(f.mobile.value, f.cc.value));
    mark($$('.choice', form)[0], !form.querySelector('[name="shop"]:checked'));
    mark($$('.choice', form)[1], !form.querySelector('[name="sport"]:checked'));
    if (!ok) form.querySelector('.is-bad input')?.focus();
    return ok;
  }

  async function subscribe(t) {
    if (!CONFIG.klaviyoList || !location.protocol.startsWith('http')) throw new Error('unavailable');
    const base = 'https://a.klaviyo.com/client';
    const headers = { 'Content-Type': 'application/vnd.api+json', revision: '2025-01-15' };
    const postSubscription = async withSms => {
      const subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };
      const profile = { email: t.email, subscriptions };
      // An email-only signup must not depend on whether Klaviyo accepts the phone number.
      if (withSms) {
        profile.phone_number = t.mobile;
        subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
      }
      const sub = await fetch(`${base}/subscriptions/?company_id=${CONFIG.klaviyoCompany}`, {
        method: 'POST', headers,
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          custom_source: 'Black Friday 2026 landing page',
          profile: { data: { type: 'profile', attributes: profile } }
        }, relationships: { list: { data: { type: 'list', id: CONFIG.klaviyoList } } } } })
      });
      if (sub.ok) return;
      const body = await sub.json().catch(() => null);
      const detail = body?.errors?.[0];
      const error = new Error('subscribe');
      error.status = sub.status;
      error.code = detail?.code;
      error.pointer = detail?.source?.pointer;
      throw error;
    };
    try {
      await postSubscription(t.sms);
    } catch (error) {
      if (!t.sms || ![400, 409, 422].includes(error.status)) throw error;
      // Keep the email signup if Klaviyo rejects the optional SMS channel.
      await postSubscription(false);
      t.sms = false;
      t.smsUnavailable = true;
    }
    await fetch(`${base}/profiles/?company_id=${CONFIG.klaviyoCompany}`, {
      method: 'POST', headers,
      body: JSON.stringify({ data: { type: 'profile', attributes: {
        email: t.email, first_name: t.first, last_name: t.last,
        properties: { 'BF26 Shop': t.shop, 'BF26 Ride or Run': t.sport, 'BF26 Ticket': t.num }
      } } })
    }).catch(() => {});
  }

  function renderPrinted(t) {
    holder.innerHTML = $('#printed').innerHTML;
    const tk = holder.firstElementChild;
    $$('[data-p="name"]', tk).forEach(el => el.textContent = `${t.first} ${t.last}`);
    $$('[data-p="shop"]', tk).forEach(el => el.textContent = `${t.shop} · ${t.sport}`);
    $$('[data-p="num"]', tk).forEach(el => el.textContent = t.num);
    $$('[data-p="tag"]', tk).forEach(el => el.textContent = `Issued to ${t.first}`);
    barcode($('[data-p="barcode"]', tk), t.num);

    head.title.textContent = `You're in, ${t.first}. Don't lose it.`;
    head.lead.textContent = `Nº ${t.num}. Wednesday 4 November, 12pm AEST, you're in while everyone else is still refreshing. We'll ping ${t.email}${t.sms ? ' and your phone' : ''} so you don't sleep through it.${t.smsUnavailable ? ' We could not add text updates, so look out for the email.' : ''}`;
    head.actions.hidden = false;
  }

  function renderIntroPrinted(t) {
    introForms.forEach(form => {
      form.innerHTML = `<div class="sale-intro__signup-success" role="status">
        <span class="mono">Early access confirmed</span>
        <h2>You're in, <span data-intro-name></span>.</h2>
        <p>We'll email <span data-intro-email></span> when the sale opens.</p>
        ${t.smsUnavailable ? '<p>Text updates could not be added. Your email sign-up is confirmed.</p>' : ''}
      </div>`;
      $('[data-intro-name]', form).textContent = t.first;
      $('[data-intro-email]', form).textContent = t.email;
    });
  }

  function renderIntroForms() {
    introForms.forEach((form, index) => {
      form.innerHTML = introFormTpls[index];
      bindForm(form, 'intro');
    });
  }

  function renderForm() {
    holder.innerHTML = formTpl;
    $$('[data-barcode]', holder).forEach(el => barcode(el, '804211'));
    head.title.innerHTML = headDefault.title;
    head.lead.textContent = headDefault.lead;
    head.actions.hidden = true;
    bindForm($('[data-form]', holder), 'ticket');
    renderIntroForms();
  }

  function bindForm(form, origin) {
    if (!form) return;
    const updateReady = () => {
      if (origin !== 'intro') return;
      const f = form.elements;
      const ready = Boolean(
        f.first.value.trim() && f.last.value.trim() &&
        /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(f.email.value.trim()) &&
        normaliseMobile(f.mobile.value, f.cc.value) &&
        form.querySelector('[name="shop"]:checked') &&
        form.querySelector('[name="sport"]:checked')
      );
      form.classList.toggle('is-ready', ready);
    };
    form.addEventListener('input', e => {
      e.target.closest('.is-bad')?.classList.remove('is-bad');
      updateReady();
    });
    form.addEventListener('change', e => {
      e.target.closest('.is-bad')?.classList.remove('is-bad');
      updateReady();
    });
    updateReady();
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const err = $('[data-err]', form);
      err.textContent = '';
      if (!validate(form)) return;
      const f = form.elements;
      const t = {
        first: f.first.value.trim().replace(/\s+/g, ' '),
        last: f.last.value.trim().replace(/\s+/g, ' '),
        email: f.email.value.trim().toLowerCase(),
        mobile: normaliseMobile(f.mobile.value, f.cc.value),
        shop: form.querySelector('[name="shop"]:checked').value,
        sport: form.querySelector('[name="sport"]:checked').value,
        sms: f.sms.checked,
        num: pad(nextNumber())
      };
      const btn = $('[data-print]', form);
      const originalBtnText = btn.textContent;
      btn.disabled = true; btn.textContent = 'Getting you in';
      try {
        await Promise.all([roll($$('[data-num]', form), t.num), subscribe(t)]);
      } catch (error) {
        btn.disabled = false; btn.textContent = originalBtnText;
        $$('[data-num]', form).forEach(el => el.textContent = '——————');
        console.warn('Black Friday signup failed', { status: error.status || null, code: error.code || null, pointer: error.pointer || null });
        err.textContent = error.message === 'unavailable'
          ? 'Sign-up needs the website to be served over HTTP or HTTPS.'
          : error.pointer?.endsWith('/email')
            ? 'That email address was not accepted. Check it and try again.'
            : error.status === 429
              ? 'Too many sign-up attempts right now. Please wait a moment and try again.'
              : 'We could not complete sign-up right now. Please try again in a moment.';
        return;
      }
      await wait(250);
      if (origin === 'ticket') await play('is-in');
      renderPrinted(t);
      renderIntroPrinted(t);
      store.set(t);
      if (origin === 'ticket') {
        $('#ticket').scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
        await play('is-out');
      }
    });
  }

  const saved = store.get();
  if (saved && saved.num) {
    renderPrinted(saved);
    renderIntroPrinted(saved);
  } else {
    bindForm($('[data-form]', holder), 'ticket');
    introForms.forEach(form => bindForm(form, 'intro'));
  }

  /* After printing */
  $('[data-reset]').addEventListener('click', async () => {
    store.clear();
    await play('is-in');
    renderForm();
    await play('is-out');
    $('#f-first', holder)?.focus({ preventScroll: true });
  });

  $('[data-cal]').addEventListener('click', () => {
    const stamp = d => d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
    const ics = [
      'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Black Sheep//Black Friday 2026//EN', 'BEGIN:VEVENT',
      `UID:bf26-early-access@blacksheep.cc`, `DTSTAMP:${stamp(new Date())}`,
      `DTSTART:${stamp(CONFIG.earlyAccess)}`, `DTEND:${stamp(CONFIG.publicSale)}`,
      'SUMMARY:Black Sheep Black Friday: you get in first',
      `DESCRIPTION:Early access gets you in 24 hours before everyone else. Up to 60% off everything. Go. ${CONFIG.shopUrl}`,
      `URL:${CONFIG.shopUrl}`,
      'BEGIN:VALARM', 'TRIGGER:-PT15M', 'ACTION:DISPLAY', 'DESCRIPTION:15 minutes. Hold yourself together.', 'END:VALARM',
      'END:VEVENT', 'END:VCALENDAR'
    ].join('\r\n');
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([ics], { type: 'text/calendar' }));
    a.download = 'black-sheep-early-access.ics';
    a.click();
    setTimeout(() => URL.revokeObjectURL(a.href), 2000);
  });

  $('[data-share]').addEventListener('click', async e => {
    const btn = e.currentTarget;
    const data = { title: 'Black Sheep Black Friday', text: 'I\'m getting in early on the Black Sheep Black Friday sale. Sign up or settle for my leftovers.', url: location.href.split('#')[0] };
    try {
      if (navigator.share) { await navigator.share(data); return; }
      await navigator.clipboard.writeText(data.url);
      btn.textContent = 'Copied. Spread it around';
      setTimeout(() => btn.textContent = 'Tell a mate. Or not.', 2200);
    } catch {}
  });

  /* Redactions */
  $$('.redact').forEach(r => r.addEventListener('click', () => {
    r.classList.remove('is-peek'); void r.offsetWidth; r.classList.add('is-peek');
    clearTimeout(r._t); r._t = setTimeout(() => r.classList.remove('is-peek'), 1400);
  }));

  /* Prize tickets lean toward the pointer */
  if (!still && matchMedia('(hover: hover)').matches) {
    $$('.tilt').forEach(el => {
      el.addEventListener('pointermove', e => {
        const r = el.getBoundingClientRect();
        el.style.setProperty('--ry', `${((e.clientX - r.left) / r.width - .5) * 5}deg`);
        el.style.setProperty('--rx', `${((e.clientY - r.top) / r.height - .5) * -5}deg`);
      });
      el.addEventListener('pointerleave', () => { el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg'); });
    });
  }
  /* Prize film: still for reduced motion, paused off screen */
  $$('[data-prize-video]').forEach(v => {
    if (still) { v.removeAttribute('autoplay'); v.pause(); return; }
    if ('IntersectionObserver' in window) new IntersectionObserver(es => es.forEach(e => e.isIntersecting ? v.play().catch(() => {}) : v.pause())).observe(v);
  });

  /* Photography drifts with the scroll */
  if (!still) {
    const stages = $$('.stage');
    let ticking = false;
    const drift = () => {
      const vh = innerHeight;
      stages.forEach(st => {
        const r = st.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const p = (vh - r.top) / (vh + r.height);
        st.style.setProperty('--py', `${(25 + p * 30).toFixed(1)}%`);
      });
      ticking = false;
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(drift); } }, { passive: true });
    drift();
  }

  /* Keep the first FAQ heading level with the overview body copy. */
  const faqIntro = $('.v1-faq-section .faq-intro');
  const faqList = $('.v1-faq-section .faq-list');
  if (faqIntro && faqList) {
    const faqLead = $('.lead', faqIntro);
    const alignFaq = () => faqList.style.setProperty('--faq-copy-offset', `${faqLead.offsetTop}px`);
    alignFaq();
    if ('ResizeObserver' in window) new ResizeObserver(alignFaq).observe($('h2', faqIntro));
    addEventListener('resize', alignFaq);
    document.fonts?.ready.then(alignFaq);
  }

  const faqItems = $$('.v1-faq-section .faq-item');
  faqItems.forEach(item => {
    item.addEventListener('toggle', () => {
      if (!item.open) return;
      faqItems.forEach(otherItem => {
        if (otherItem !== item) otherItem.open = false;
      });
    });
  });

})();
